"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _Enable2FAModal = _interopRequireDefault(require("./Enable2FAModal"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _userActions = require("../../redux/actions/userActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    GoogleQRCode: state.user.qrCode.ManualCode,
    userName: state.user.userInfo.UserName
  };
};
var mapDispatchToProps = {
  changeFieldValue: _reduxForm.change
};
var FORM = 'enable2FAModal';
var containerForm = (0, _reduxForm.reduxForm)({
  form: FORM,
  enableReinitialize: true,
  onSubmit: function onSubmit(payload, dispatch, _props) {
    if (payload && payload.code) {
      dispatch((0, _reduxForm.reset)(FORM, 'code'));
      dispatch((0, _reduxForm.untouch)(FORM, 'code'));
      return dispatch((0, _userActions.enable2FA)(payload.code));
    }
    dispatch((0, _reduxForm.reset)(FORM, 'otp'));
    dispatch((0, _reduxForm.untouch)(FORM, 'otp'));
    return dispatch((0, _userActions.enableYubikey2FA)(payload.otp));
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(_Enable2FAModal["default"]);
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(containerForm);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.ENABLE_2FA
})(container);